module.exports = __webpack_public_path__ + "static/media/FolderRedDark.351a33c9.svg";